import React, { } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import SimuladoResultadoTable from '../SimuladoResultadoTable';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    title: {
        marginBottom: '20px',
    },
    voltarButton: {
        marginBottom: '20px',
        marginRight: '10px',
        cursor: 'pointer'
    }
});

export default function AvaliacaoResultadoContainer() {
    const classes = useStyles();

    return (
        <div>
            <Container className={classes.paper} component={Paper}>
                <Link to={{
                    pathname: '/avaliacao'
                }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.voltarButton}
                    >
                        <ArrowBackIcon style={{ marginRight: '10px' }} />
                        Voltar
                    </Button>
                </Link>
                <Typography className={classes.title} variant="h6">
                    Resultado
                </Typography>


                <SimuladoResultadoTable />
            </Container>

        </div>
    );
}